import React, { useState } from 'react'
import * as txApi from '../clients/tx-sls-client'
import {config} from '../config'
import Modal from 'react-bootstrap/Modal'
import AdSenseWidget from './AdSenseWidget'; // adjust the path according to your folder structure

import TournamentDropdown from './TournamentDropdown'

const TourneyOverview = ({ tournamentDetails,user_information,get_pinned_tournaments }) => {

  const linodeurl = config()['linode-url'];
  const txdomain = config()['tourneyx-url']
  const entryFees = (tournamentDetails.entry_fees) ? JSON.parse(tournamentDetails.entry_fees)  : []
  const mainEntryFee = (entryFees) ? entryFees[0] : {}
  const extraFees = (entryFees) ? entryFees[1] : {}
  const firstName = (tournamentDetails.first_name) ? tournamentDetails.first_name : ''
  const lastName = (tournamentDetails.last_name) ? tournamentDetails.last_name : ''
  const [isShowPinnedTournaments, setPinTourneyLoaded] = useState(false)
  const [isTournamentAlreadyPinned, markTourneyAsPinned ] = useState(false)
  const currencySymbol = tournamentDetails.currency_symbol;
  const currencyCode = tournamentDetails.currency_code; //TP-401 Jira card :: Added currency code
  
  // Chaitraly 24/Jun/2024 :: TP-379 Jira card :: variables
  const ebf_angler_name = 
  (tournamentDetails.event_big_fish && tournamentDetails.event_big_fish.length > 0 && tournamentDetails.event_big_fish[0].angler_name) 
  ? tournamentDetails.event_big_fish[0].angler_name 
  : 'none';

  const ebf_fish_type = 
    (tournamentDetails.event_big_fish && tournamentDetails.event_big_fish.length > 0 && tournamentDetails.event_big_fish[0].fish_type) 
    ? tournamentDetails.event_big_fish[0].fish_type 
    : 'unknown';

  const ebf_fish_length = 
    (tournamentDetails.event_big_fish && tournamentDetails.event_big_fish.length > 0 && tournamentDetails.event_big_fish[0].fish_length) 
    ? tournamentDetails.event_big_fish[0].fish_length 
    : '0';

  const ebf_fish_weight = 
    (tournamentDetails.event_big_fish && tournamentDetails.event_big_fish.length > 0 && tournamentDetails.event_big_fish[0].fish_weight) 
    ? tournamentDetails.event_big_fish[0].fish_weight 
    : '0';

  const ebf_fish_photo = 
    (tournamentDetails.event_big_fish && tournamentDetails.event_big_fish.length > 0 && tournamentDetails.event_big_fish[0].photo) 
    ? tournamentDetails.event_big_fish[0].photo 
    : 'no_image.jpg';

  const imageID = (tournamentDetails.event_big_fish && tournamentDetails.event_big_fish.length > 0 && tournamentDetails.event_big_fish[0].id) 
  ? tournamentDetails.event_big_fish[0].id 
  : 0;

  const [show, setShow] = useState(false);
  const handleClose = (event) => {
    setShow(false)
  }
  const handleShow = () => {
    setShow(true);
  }

  //console.log('Extra fees value found for the tournament:::',extraFees);


  // We will also have to check if the viewed tournament has been pinned or unpinned by angler.
  // Change added on 03-26-2021

  const extractFishTypes = (fishTypes) => {
    return (Object.prototype.toString.call(fishTypes[0]) === '[object Object]')
      ? fishTypes.map(x => Object.keys(x))
      : fishTypes
  }
  
  const fishTypes = (tournamentDetails.fish_types) ? extractFishTypes(JSON.parse(tournamentDetails.fish_types)) : []

  var tournament_id_to_check = tournamentDetails.id;
  var tournament_id_results = [];
  var pinned_tournaments_list = [];

  if(isShowPinnedTournaments === false && get_pinned_tournaments.length){

    pinned_tournaments_list = get_pinned_tournaments;

    get_pinned_tournaments.map((tournament,index) =>{
      tournament_id_results.push(tournament.id);
    });
    setPinTourneyLoaded(true) 
    

    if( (tournament_id_results.indexOf(tournament_id_to_check) > -1) == true   ){
      console.log('Tournament selected is already pinned by angler for tourney id::',tournament_id_to_check);
      markTourneyAsPinned(true)
    }else{
      markTourneyAsPinned(false)
    }

 
  }else{
    // Do no calculations for finding pinned tournaments
  }
  
  const unPinSelectedTournament = (tournament_id, user_id) => {
    console.log('Tournament id to be UNPINNED against user id :::', tournament_id,user_id);

    txApi.unpinSelectedTournament(tournament_id,user_id)
      .then(unpinned_response => 
      {          
        console.log('unpinned selected tournament response:::',unpinned_response)
        window.location.reload(false)
      })
      .catch(error => {
      console.error(`Error loading unpinned tournament response ${error}`)
    
      })
      .finally(() => {})

  }

  const pinSelectedTournament = (tournament_id,user_id) => {
    console.log('Tournament id to be PINNED against user id :::', tournament_id,user_id);

    txApi.setPinnedTournament(tournament_id,user_id)
      .then(pinned_response => 
      {          
        console.log('pinned selected tournament response:::',pinned_response)
        window.location.reload(false)
        //alert('Tournament has been pinned!');
        //pinned_tournaments_list = pinned_response;
      })
      .catch(error => {
      console.error(`Error loading pinned tournament response ${error}`)
    
      })
      .finally(() => {})

    }




  //$efees[0]['Entry_Fee'] == '' || $efees[0]['Entry_Fee'] == '0.00'

  const getMainFee = (mainEntryFee) => {

    // Commented hard-coded $ currency symbol code
    // Change added on 08-12-2021
    //const fee = (mainEntryFee) ? `$${mainEntryFee.Entry_Fee}` : ''
    // TP-401 Jira card :: Added currencyCode
    const fee = (mainEntryFee) ? `${currencySymbol} ${mainEntryFee.Entry_Fee} ${currencyCode}` : ''

    if( mainEntryFee && ( mainEntryFee.Entry_Fee === '' || mainEntryFee.Entry_Fee === '0.00' || mainEntryFee.Entry_Fee === '0' || mainEntryFee.Entry_Fee === '0.0') ){
      return 'See Description Details'
    }else{
      return (fee === '$0.00') ? 'See Description Details' : fee
    }
   
  }

  const extractExtraFees= (extra_fees) => {
    return (Object.prototype.toString.call(extra_fees[0]) == '[object Object]')
      ? extra_fees.map(x => Object.keys(x))
      : extra_fees
  }

  const getExtraFees = (extraFees) => {
    const additional_extra_fee = Object.keys(extraFees).map(function(k) {
      return extraFees[k];
    });

    console.log('additional_extra_fee output:::', additional_extra_fee);

    // Commented hard-coded $ currency symbol code
    // Change added on 08-12-2021
    //return additional_extra_fee.filter(fee => fee.name.trim() !== '' && fee.cost.trim() !== '').map(fee => <><b>{`${fee.name}:`}</b>{` $${fee.cost}`}<br/></>) 
    
    return additional_extra_fee.filter(fee => fee.name.trim() !== '' && fee.cost.trim() !== '').map(fee => <><b>{`${fee.name}:`}</b>{` ${currencySymbol} ${fee.cost} ${currencyCode}`}<br/></>) 
  
  }

  return (
    <>

      
        {
          ( isTournamentAlreadyPinned && user_information && user_information.user_id !== null) ?
          
          // The below condition will work for unpinning logged in user id

          (user_information && user_information.user_id !== null && user_information.emulate_user_id === null ) ?
         
          <div className="sidebar-widget " id="tourney-pin" onClick={() => unPinSelectedTournament(tournamentDetails.id,user_information.user_id )}>
            <div className="pin-tourney pinned">
              <i className="fa fa-thumb-tack" aria-hidden="true"></i>
              <span className="pinned-text">&nbsp;&nbsp; Unpin this tournament</span>
            </div>
          </div>

          :

          // Check for super-admin emulating any director/angler, refer his user_id value
          (user_information && user_information.emulate_user_id && user_information.emulate_user_id !== null) ?
          <div className="sidebar-widget " id="tourney-pin" onClick={() => unPinSelectedTournament(tournamentDetails.id,user_information.emulate_user_id )}>
            <div className="pin-tourney pinned">
              <i className="fa fa-thumb-tack" aria-hidden="true"></i>
              <span className="pinned-text">&nbsp;&nbsp; Unpin this tournament</span>
            </div>
          </div>
         :

          // For emulate_user_id !== null condition 
          null


          :
          // For user_id !== null condition
          null
        }


        {
          /*
            Check if tournament is not already pinned, then pin the tournament
          */
        }

        {

          ( (!isTournamentAlreadyPinned) && user_information && user_information.user_id !== null) ?
         
          // The below condition will work for unpinning logged in user id

          (user_information && user_information.user_id !== null && user_information.emulate_user_id === null) ?
          
          <div className="sidebar-widget " id="tourney-pin" onClick={() => pinSelectedTournament(tournamentDetails.id,user_information.user_id)}>
            <div className="pin-tourney">
              <i className="fa fa-thumb-tack" aria-hidden="true"></i>
              <span className="pinned-text">&nbsp;&nbsp; Pin Tournament</span>
            </div>
          </div>

          :

          // Check for super-admin emulating any director/angler, refer his user_id value
          (user_information && user_information.emulate_user_id && user_information.emulate_user_id !== null) ?

          <div className="sidebar-widget " id="tourney-pin" onClick={() => pinSelectedTournament(tournamentDetails.id,user_information.emulate_user_id )}>
            <div className="pin-tourney">
              <i className="fa fa-thumb-tack" aria-hidden="true"></i>
              <span className="pinned-text">&nbsp;&nbsp; Pin Tournament</span>
            </div>
          </div>

          :

          // For emulate_user_id !== null condition 
          null


          :
          
          // For user_id !== null condition
          null


        }
       

      {/* Chaitraly 20/Jun/2024 :: TP-379 jira card */}
      <div>
      {tournamentDetails.event_big_fish && tournamentDetails.event_big_fish.length > 0 ? (
        <div className="sidebar-widget" id="tourney-overview">
          {/* <h3>Event Big Fish</h3>{ebf_angler_name}<br></br> //old code */}
          <h3> {tournamentDetails.tourney_type == 20 ? 'Event Small Fish' : 'Event Big Fish' }</h3>{ebf_angler_name}<br></br>
          {ebf_fish_type} 
          {tournamentDetails.measurement_type === 'weight' ? (
            ` ${ebf_fish_weight} lbs`
          ) : (
            ` ${ebf_fish_length}"`
          )}
          <div className='fish-img'>
          <a target="#" onClick={handleShow}>
            <img id='#tourneylogo' src={`${linodeurl}/submissions/${tournamentDetails.id}/${ebf_fish_photo}`}
            onError={(event) => {event.target.src = '/no_submit_photo2.jpg'}}/>
          </a>

          {/* added below code to open fish submission image on clicking event big fish  */}
          <Modal dialogClassName="pic-modal" show={show} onHide={handleClose} animation={false} centered>
              <Modal.Header closeButton>
              </Modal.Header>
              <Modal.Body style={{'height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}} >
                <div className='fish-img'>
                  <img src={`${txdomain}/app/lib/php/show_image.php?s=${imageID}`} onClick={handleClose}
                    onError={(e) => e.target.src = '/no_submit_photo2.jpg'} />
                </div>        
              </Modal.Body>
          </Modal>
          </div>
        </div>
      ) : (
        <div></div>
      )}
      </div>

      <div className="sidebar-widget" id="tourney-overview">
        <h3>Tourney Director</h3>{firstName} {lastName}

        <div className="hide-mobile">
          <br/>
          <br/>
          
          <TournamentDropdown otherTournamentsList={tournamentDetails.other_tournaments_list ? tournamentDetails.other_tournaments_list : null} tournamentInfo = {tournamentDetails} />

        </div>
    

        <br/>
        
        <hr/>

        <h3>Fish Types</h3>
        {(fishTypes)
          ? fishTypes.map((fishType, index) => `${fishType}${(index+1 !== fishTypes.length) ? ', ' : ''}`)
          : <></>
        }
        <hr />
        <h3>Fees</h3>
        <b>Entry Fee: </b>{getMainFee(mainEntryFee)}<br />
      
        {
          (extraFees && extraFees.Extra_Fee) ?
          
          getExtraFees(extraFees.Extra_Fee)
          :null

        }
          
      </div> 

      {/* <div className="sidebar-widget" id="google-adsense"> */}
        
      {/* <AdSenseWidget /> */}
        
      {/* </div> */}


    </>
  )

  
}

export default TourneyOverview